import classNames from 'classnames';

import { Label } from '@zooplus/ui-components';

import styles from './FormControlWrapper.module.scss';
import FormMessages from './FormMessages';

export type FormControlWrapperProps = {
  labelInline: boolean;
  label?: string;
  labelFor?: string;
  infoMessageIcon?: React.ReactNode;
  infoMessage?: React.ReactNode;
  errorMessage?: React.ReactNode;
  errorZta?: string;
};

const FormControlWrapper: React.FC<FormControlWrapperProps> = ({
  children,
  labelInline,
  label,
  labelFor,
  infoMessageIcon,
  infoMessage,
  errorMessage,
  errorZta,
}) => {
  return (
    <div className={classNames(styles.formControlWrapper, labelInline && styles.labelInline)}>
      {label && (
        <Label className={styles.formControlLabel} htmlFor={labelFor}>
          {label}
        </Label>
      )}
      <div className={classNames({ [styles.spacer]: !label })}></div>
      <div>
        {children}
        <FormMessages
          infoMessage={infoMessage}
          errorMessage={errorMessage}
          infoMessageIcon={infoMessageIcon}
          errorZta={errorZta}
        />
      </div>
    </div>
  );
};

export default FormControlWrapper;
